module.exports = __webpack_public_path__ + "img/ydnxy.0bb1a442.png";